import React, { createContext, useContext, useState, useEffect } from 'react';

type LayoutMode = 'top-nav' | 'sidebar';

interface LayoutContextType {
    layoutMode: LayoutMode;
    setLayoutMode: (mode: LayoutMode) => void;
}

const LayoutContext = createContext<LayoutContextType | undefined>(undefined);

export const LayoutProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [layoutMode, setLayoutModeState] = useState<LayoutMode>(() => {
        const saved = localStorage.getItem('layoutMode') as LayoutMode;
        return saved || 'sidebar'; // Default to sidebar (Maistre style)
    });

    useEffect(() => {
        localStorage.setItem('layoutMode', layoutMode);
    }, [layoutMode]);

    const setLayoutMode = (mode: LayoutMode) => {
        setLayoutModeState(mode);
    };

    return (
        <LayoutContext.Provider value={{ layoutMode, setLayoutMode }}>
            {children}
        </LayoutContext.Provider>
    );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useLayout = () => {
    const context = useContext(LayoutContext);
    if (context === undefined) {
        throw new Error('useLayout must be used within a LayoutProvider');
    }
    return context;
};
